import { action, makeObservable, observable } from 'mobx'
import { AuthApiError } from '@okta/okta-auth-js'
import { createContext } from 'react'
import { FustCodeItemState } from '../services/api/types'

export type GlobalAppError = Partial<AuthApiError> & { errorTitle?: string }
export type GlobalAppWarning = {
  warningTitle?: string
  warningSummary?: string
  warningLink?: string
}

export class GlobalStore {
  globalAppError: GlobalAppError | undefined
  fustCodeItemStates: FustCodeItemState[] | undefined
  globalAppWarning: GlobalAppWarning | undefined

  constructor() {
    makeObservable(this, {
      globalAppError: observable,
      globalAppWarning: observable,
      setGlobalAppError: action,
      setGlobalAppWarning: action,
      fustCodeItemStates: observable,
      setFustCodeItemStates: action,
    })
  }

  setGlobalAppError(error: GlobalAppError | undefined) {
    this.globalAppError = error
  }

  setGlobalAppWarning(warning: GlobalAppWarning | undefined) {
    this.globalAppWarning = warning
  }

  setFustCodeItemStates(fustCodeItemStates: FustCodeItemState[] | undefined) {
    this.fustCodeItemStates = fustCodeItemStates
  }
}

const globalStore = new GlobalStore()
export const GlobalStoreContext = createContext<GlobalStore>(globalStore)
export default globalStore
